import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/PaginatePublic.vue'
import {comma} from '@/components/mixins/comma'
export const myPoint = {
    data(){
        return{
            isLoading:true
        }
    },
    mixins:[
        comma    
    ],
    components:{
        DisplayTime,
        Paginate       
    }, 
    mounted(){
        this.fetchLists();
    },
    computed:{
        pointLogs:{            
            get(){                 
                return this.$store.state.point.pointLogs;
            }
        },
    },
    methods:{
        test(data){
            alert(data);
        },
        async fetchLists(pagenumber) {
            const formData = {               
                user_id:this.$store.getters.currentUser.id,
                getmypost:true,
                page:pagenumber?pagenumber:1
            }
            try {
                const response = await this.$store.dispatch("point/getPointLogs", formData)
                //console.log(response);
                this.pointLogs = response.data.reverse();
                //console.log("안나오는듯",this.postlists.data.length);          
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
    }
}